"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyleModule = void 0;
var inversify_1 = require("inversify");
var acorn_react_core_1 = require("@gcdtech/acorn-react-core");
var StyleGuide_1 = require("../screens/StyleGuide");
var StyleModule = /** @class */ (function (_super) {
    __extends(StyleModule, _super);
    function StyleModule() {
        return _super.call(this, function (bind) {
            bind(acorn_react_core_1.CORE_TYPES.Route).toConstantValue({
                type: 'component',
                authenticated: false,
                path: '/style',
                component: StyleGuide_1.StyleGuide,
            });
            bind(acorn_react_core_1.CORE_TYPES.NavItem).toConstantValue({
                to: '/style',
                text: 'Style Guide',
                authenticated: false,
                order: 1000
            });
        }) || this;
    }
    return StyleModule;
}(inversify_1.ContainerModule));
exports.StyleModule = StyleModule;
//# sourceMappingURL=StyleModule.js.map